import { TypographyProps, TypographyRounded } from "@/components";

export type Props = TypographyProps;

export const HeadingRounded: React.FC<Props> = (props) => {
  return <TypographyRounded size="large" displaytext="flex" {...props} />;
};
